module.exports = __webpack_public_path__ + "img/lg_ring_r_e_0_null.3ab9542b.png";